import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React__default from 'react';

var _excluded = ["size", "style", "title"];
var IllustrationFileBox = function IllustrationFileBox(_ref) {
  var size = _ref.size,
      style = _ref.style,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: size || 400,
    height: size || 400,
    viewBox: "0 0 400 400",
    fill: "none",
    style: style,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("title", null, title || "File Box"), /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("g", {
    filter: "url(#illustration-file-box__filter0_f_2306_101038)"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M304.653 346.607H61L171.412 282.607H375L304.653 346.607Z",
    fill: "url(#illustration-file-box__paint0_linear_2306_101038)"
  })), /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("path", {
    d: "M77.4101 241.743L165.408 195.397C166.088 195.039 166.834 194.853 167.591 194.853H353.473C355.515 194.853 356.682 197.358 355.457 199.115L282.183 301.106L77.8736 246.713C75.6504 246.087 75.3466 242.83 77.4101 241.743Z",
    fill: "url(#illustration-file-box__paint1_linear_2306_101038)"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M165.6 247.391V197.667C165.6 196.271 166.384 194.853 167.78 194.853H353.475C355.516 194.853 356.681 197.358 355.458 199.115L283.453 300.445C282.703 301.501 281.488 302.128 280.192 302.128H89.898C85.8077 302.128 84.3542 296.714 87.8944 294.666L163.603 250.853C164.839 250.138 165.6 248.818 165.6 247.391Z",
    fill: "url(#illustration-file-box__paint2_linear_2306_101038)"
  }), /*#__PURE__*/React__default.createElement("g", {
    filter: "url(#illustration-file-box__filter1_dd_2306_101038)"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M166.115 250.023H344.539C348.518 250.023 350.057 255.201 346.723 257.374L283.766 298.414C283.117 298.837 282.358 299.063 281.582 299.063H93.3072C89.1929 299.063 87.7589 293.599 91.3431 291.578L164.15 250.539C164.75 250.201 165.426 250.023 166.115 250.023Z",
    fill: "#979AB8"
  })), /*#__PURE__*/React__default.createElement("path", {
    d: "M283.98 303.036C283.318 303.511 282.397 303.038 282.397 302.223V243.202C282.397 241.277 283.336 239.497 284.86 238.532L353.273 195.221C354.919 194.179 356.978 195.477 356.978 197.555V247.777C356.978 249.596 356.141 251.292 354.75 252.289L283.98 303.036Z",
    fill: "url(#illustration-file-box__paint3_linear_2306_101038)"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M75 297.779V244.778C75 241.922 77.2326 239.607 79.9867 239.607H140.725C143.479 239.607 145.673 241.932 145.937 244.775C146.484 250.652 147.923 253.951 149.109 255.486C149.651 256.188 150.532 256.413 151.399 256.413H207.422C210.763 256.028 212.469 249.887 213.208 244.551C213.589 241.804 215.77 239.607 218.446 239.607H279.454C282.208 239.607 284.441 241.922 284.441 244.778V297.779C284.441 300.635 282.208 302.95 279.454 302.95H79.9867C77.2326 302.95 75 300.635 75 297.779Z",
    fill: "url(#illustration-file-box__paint4_linear_2306_101038)"
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: 276,
    y: 254,
    width: 54,
    height: 6,
    rx: 3,
    transform: "rotate(-180 276 254)",
    fill: "#2A4BF4"
  })), /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.056 60.2792C111.814 58.8765 115.997 60.7874 117.399 64.5474L139.658 124.274C141.059 128.034 139.148 132.219 135.389 133.622C131.63 135.025 127.447 133.114 126.046 129.354L103.787 69.6272C102.386 65.8672 104.297 61.682 108.056 60.2792Z",
    fill: "#FADB14"
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.321 90.6277C204.8 92.6244 206.002 97.065 204.005 100.546L186.782 130.577C184.785 134.058 180.346 135.262 176.867 133.265C173.387 131.269 172.185 126.828 174.182 123.347L191.406 93.3158C193.402 89.8346 197.842 88.6311 201.321 90.6277Z",
    fill: "#FADB14"
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.6179 161.209C98.6153 165.095 94.6538 167.433 90.7696 166.431L55.6054 157.358C51.7212 156.356 49.3853 152.394 50.3879 148.508C51.3905 144.622 55.352 142.284 59.2361 143.286L94.4004 152.358C98.2845 153.36 100.62 157.323 99.6179 161.209Z",
    fill: "#FADB14"
  }))), /*#__PURE__*/React__default.createElement("defs", null, /*#__PURE__*/React__default.createElement("filter", {
    id: "illustration-file-box__filter0_f_2306_101038",
    x: 53,
    y: 274.607,
    width: 330,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React__default.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React__default.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React__default.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_2306_101038"
  })), /*#__PURE__*/React__default.createElement("filter", {
    id: "illustration-file-box__filter1_dd_2306_101038",
    x: 83.3005,
    y: 248.023,
    width: 271.246,
    height: 61.0397,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React__default.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React__default.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React__default.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React__default.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React__default.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.380392 0 0 0 0 0.054902 0 0 0 0 0.635294 0 0 0 0.12 0"
  }), /*#__PURE__*/React__default.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2306_101038"
  }), /*#__PURE__*/React__default.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React__default.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect2_dropShadow_2306_101038"
  }), /*#__PURE__*/React__default.createElement("feOffset", null), /*#__PURE__*/React__default.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.380392 0 0 0 0 0.054902 0 0 0 0 0.635294 0 0 0 0.03 0"
  }), /*#__PURE__*/React__default.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2306_101038",
    result: "effect2_dropShadow_2306_101038"
  }), /*#__PURE__*/React__default.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2306_101038",
    result: "shape"
  })), /*#__PURE__*/React__default.createElement("linearGradient", {
    id: "illustration-file-box__paint0_linear_2306_101038",
    x1: 347.979,
    y1: 273.78,
    x2: 361.456,
    y2: 287.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React__default.createElement("stop", {
    stopColor: "#610EA2",
    stopOpacity: 0.1
  }), /*#__PURE__*/React__default.createElement("stop", {
    offset: 1,
    stopColor: "#610EA2",
    stopOpacity: 0.1
  })), /*#__PURE__*/React__default.createElement("linearGradient", {
    id: "illustration-file-box__paint1_linear_2306_101038",
    x1: 134,
    y1: 183,
    x2: 297.11,
    y2: 231.553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React__default.createElement("stop", {
    stopColor: "#D5D3E4"
  }), /*#__PURE__*/React__default.createElement("stop", {
    offset: 1,
    stopColor: "#9EA0BF"
  }), /*#__PURE__*/React__default.createElement("stop", {
    offset: 1,
    stopColor: "#9EA0BF"
  })), /*#__PURE__*/React__default.createElement("linearGradient", {
    id: "illustration-file-box__paint2_linear_2306_101038",
    x1: 161.815,
    y1: 271.666,
    x2: 222.28,
    y2: 398.568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React__default.createElement("stop", {
    stopColor: "#6F79A8",
    stopOpacity: 0.15
  }), /*#__PURE__*/React__default.createElement("stop", {
    offset: 1,
    stopColor: "#3D3D80"
  })), /*#__PURE__*/React__default.createElement("linearGradient", {
    id: "illustration-file-box__paint3_linear_2306_101038",
    x1: 273.736,
    y1: 257.343,
    x2: 382.564,
    y2: 222.259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React__default.createElement("stop", {
    stopColor: "#D6D4E6"
  }), /*#__PURE__*/React__default.createElement("stop", {
    offset: 1,
    stopColor: "#B8B5D5"
  })), /*#__PURE__*/React__default.createElement("linearGradient", {
    id: "illustration-file-box__paint4_linear_2306_101038",
    x1: 190,
    y1: 301.387,
    x2: 185.5,
    y2: 239.387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React__default.createElement("stop", {
    stopColor: "#DEDEED"
  }), /*#__PURE__*/React__default.createElement("stop", {
    offset: 0.88633,
    stopColor: "#EDEDF5"
  }))));
};

export { IllustrationFileBox };
//# sourceMappingURL=illustration-file-box.js.map
